import { render, staticRenderFns } from "./TypingUsersList.vue?vue&type=template&id=2605c78b&"
import script from "./TypingUsersList.vue?vue&type=script&lang=js&"
export * from "./TypingUsersList.vue?vue&type=script&lang=js&"
import style0 from "./TypingUsersList.vue?vue&type=style&index=0&id=2605c78b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports